<template>
    <v-table
      class="table-data"
      fixed-header>
      <thead>
        <tr>
          <th v-for="item in headers"
            :key="item" class="text-left">
            {{item}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in cuts"
          :key="item._id">
          <td>{{ item.number }}</td>
          <td>{{ formatTimestamp(item.created) }}</td>
          <td>{{item.terminal.name }}</td>
          <td>{{formatMoney(item.cash) }}</td>
          <td>{{formatMoney(item.card )}}</td>
          <td>{{formatMoney(item.cash + item.card) }}</td>
        </tr>
      </tbody>
    </v-table>

</template>
<script>
import dateTransform from '@/utils/dateTransform'
import moneyTransform from '@/utils/moneyTransform'
export default {
  name: 'CommerciaVueCutsTable',
  props: {
    cuts: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      headers: ['No.', 'Fecha', 'POS', 'Efectivo', 'Tarjeta', 'Total']
    }
  },

  methods: {
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    },
    formatMoney (intValue) {
      return moneyTransform.intToMoney(intValue)
    }
  }

}
</script>
